<script>
import { getCategoryList, saveCategory, deleteCategory, uploadCategoryImage } from '@/api/category'

export default {
  name: 'Fabrication',
  data() {
    return {
      ifTipMode:false,
      categoryPopupVisible: false,
      categoryEditVisible: false,
      categories: [],
      selectedCategoryId: '',
      tempSelectedCategoryId: '',
      editCategory: {
        id: '',
        name: '',
        imgUrl: '',
        imgOssId: ''
      },
      uploadingCategoryImg: false,
      books: {
        title: '',
        intro: '',
        freeContent: '',
        paidContent: '',
        price: '',
        ifRefund: false,
        templateIndex: 0,

      },
    }
  },
  mounted () {
    this.fetchCategories()
  },
  methods: {
    async fetchCategories () {
      try {
        const res = await getCategoryList()
        const raw = (res && (res.data || res.rows || res.list)) || (res && res.data && (res.data.data || res.data.list)) || []
        const list = Array.isArray(raw) ? raw : (Array.isArray(res) ? res : [])
        this.categories = list.map(this.normalizeCategory).filter(i => i && i.id)
      } catch (e) {
        this.categories = []
      }
    },
    normalizeCategory (item) {
      if (!item) return null
      const id = String(item.id || item.categoryId || item.menuId || item.channelId || item.value || '')
      const name = String(item.name || item.categoryName || item.menuName || item.channelName || item.label || '')
      const imgUrl = String(item.imgUrl || item.imageUrl || item.icon || item.logo || item.channelImgUrl || item.channelImg || item.menuImg || item.pic || '')
      const imgOssId = String(item.imgOssId || item.ossId || item.channelImg || item.categoryImg || '')
      return { id, name, imgUrl, imgOssId, raw: item }
    },
    openCategoryPicker () {
      this.tempSelectedCategoryId = this.selectedCategoryId || ''
      this.categoryPopupVisible = true
    },
    closeCategoryPicker () {
      this.categoryPopupVisible = false
    },
    confirmCategoryPicker () {
      this.selectedCategoryId = this.tempSelectedCategoryId || ''
      this.closeCategoryPicker()
    },
    openCategoryEditor (cat) {
      if (cat) {
        this.editCategory = {
          id: cat.id,
          name: cat.name || '',
          imgUrl: cat.imgUrl || '',
          imgOssId: cat.imgOssId || ''
        }
      } else {
        this.editCategory = { id: '', name: '', imgUrl: '', imgOssId: '' }
      }
      this.categoryEditVisible = true
    },
    closeCategoryEditor () {
      this.categoryEditVisible = false
    },
    async confirmCategoryEditor () {
      const name = (this.editCategory.name || '').trim()
      if (!name) {
        this.$createToast({ type: 'warn', time: 1000, txt: '请输入分类名' }).show()
        return
      }
      if (name.length > 10) {
        this.$createToast({ type: 'warn', time: 1000, txt: '分类名最多10个字' }).show()
        return
      }
      try {
        const channelImg = this.editCategory.imgOssId || this.editCategory.imgUrl || ''
        const payload = {
          id: this.editCategory.id || undefined,
          name,
          imgUrl: this.editCategory.imgUrl || '',
          // 兼容后端字段命名
          categoryId: this.editCategory.id || undefined,
          categoryName: name,
          categoryImg: channelImg,
          channelName: name,
          channelImg: channelImg
        }
        await saveCategory(payload)
        this.$createToast({ type: 'correct', time: 1000, txt: '保存成功' }).show()
        this.closeCategoryEditor()
        await this.fetchCategories()
      } catch (e) {
        this.$createToast({ type: 'warn', time: 1000, txt: '保存失败' }).show()
      }
    },
    async onCategoryFilesAdded (files) {
      const file = files && files[0]
      if (!file || file.ignore) return
      if (this.uploadingCategoryImg) return
      this.uploadingCategoryImg = true
      const loading = this.$createToast({ type: 'loading', time: 0, txt: '上传中...' })
      loading.show()
      try {
        const fd = new FormData()
        fd.append('file', file.file || file)
        const res = await uploadCategoryImage(fd)
        const data = (res && res.data) ? res.data : res
        const url = (data && (data.url || data.fileUrl || data.path)) || ''
        const ossId = (data && (data.ossId || data.ossID || data.id)) || ''
        if (!url) {
          this.$createToast({ type: 'warn', time: 1000, txt: '上传失败' }).show()
          return
        }
        this.editCategory.imgUrl = url
        this.editCategory.imgOssId = ossId ? String(ossId) : ''
        this.$createToast({ type: 'correct', time: 800, txt: '上传成功' }).show()
      } catch (e) {
        this.$createToast({ type: 'warn', time: 1000, txt: '上传失败' }).show()
      } finally {
        loading.hide()
        this.uploadingCategoryImg = false
      }
    },
    async onDeleteCategory (cat) {
      if (!cat || !cat.id) return
      try {
        await this.$createDialog({
          type: 'confirm',
          title: '提示',
          content: '确认删除该分类？'
        }).show()
      } catch (e) {
        return
      }

      const loading = this.$createToast({ type: 'loading', time: 0, txt: '删除中...' })
      loading.show()
      try {
        await deleteCategory(cat.id)
        if (this.selectedCategoryId === cat.id) {
          this.selectedCategoryId = ''
          this.tempSelectedCategoryId = ''
        }
        this.$createToast({ type: 'correct', time: 800, txt: '删除成功' }).show()
        await this.fetchCategories()
      } catch (e) {
        this.$createToast({ type: 'warn', time: 1000, txt: '删除失败' }).show()
      } finally {
        loading.hide()
      }
    },
    filesAdded(files) {
      let hasIgnore = false
      const maxSize = 1 * 1024 * 1024 // 1M
      for (let k in files) {
        const file = files[k]
        if (file.size > maxSize) {
          file.ignore = true
          hasIgnore = true
        }
      }
      hasIgnore && this.$createToast({
        type: 'warn',
        time: 1000,
        txt: 'You selected >1M files'
      }).show()
    },
    submitHandler(e, model) {
      e.preventDefault()
      console.log('表单提交', model)
      // TODO: 调用接口提交 model（含 title, intro, freeContent, paidContent, price, noRefund, templateIndex）
    },
    validateHandler(result) {
      this.validity = result.validity
      this.valid = result.valid
    }
  }
}
</script>

<template>
  <!--制作料-->
  <div class="write-wraper">
    <div class="pMode">
      <div class="p_user">
        <div class="p_uContent">
          <div class="p_u_left">
            <img src="http://oss.zhishijingling.com/haoliaodata/2023-07-12/22c77731c3ba439fa46020d3f74209c91689150310528_860.jpeg">
          </div>
          <div class="p_u_right">
            <div class="p_u_r_name">牛小彩</div>
          </div>
        </div>
      </div>
      <div>
        <img src="https://oss.zhishijingling.com/jinriyouliao/home/openTopicimg.png" class="modeIconAlbum" style="margin-right: 1rem;">
        <img src="https://oss.zhishijingling.com/jinriyouliao/jingjian.png" class="modeIcon">
      </div>
    </div>
    <div class="selected" @click="openCategoryPicker">
      <div class="s_list">
        <div class="s_l_left">分类</div>
        <div class="s_l_right">
          {{ (categories.find(c => c.id === selectedCategoryId) || {}).name || '选择(可选)' }}
        </div>
      </div>
    </div>
    <!--    注意事项-->
    <div class="tipsMode" v-if="ifTipMode">
      <div class="descBox">
        <div class="descTitle">注意事项</div>
        <div class="fontOrang">禁止出现违反国家法律法规禁止的内容:</div>
        <div class="item">（1）违反宪法确定的基本原则的;</div>
        <div class="item">（2）煽动民族仇恨、民族歧视，破坏民族团结的;</div>
        <div class="item">（3）破坏国家宗教政策,宣扬邪教和封建迷信的;</div>
        <div class="item">（4）散布谣言，扰乱社会秩序，破坏社会稳定的;</div>
        <div class="item">（5）散布淫移、色情、赌博、暴力、恐怖或者教唆犯罪的;</div>
        <div class="item">（6）侮辱或者诽谤他人，侵害他人合法权益的;</div>
        <div class="item">（7）含有法律、行政法规禁止的其他内容的。</div>
        <div>如有发现平台有权对其料内容进行下架和删除处理,感谢大家的配合。</div>
        <div class="konw" @click="ifTipMode=false">知道了</div></div>
    </div>
    <form class="cube-form book-form cube-form_invalid cube-form_fresh">
      <div class="cube-form-group">
        <p class="cube-form-group-legend"></p>
        <div class="cube-form-group-content">
          <div class="cube-form-item border-bottom-1px subtitle cube-form-item_required cube-form-item_invalid">
            <div class="cube-form-label">
              <span>标题</span>
            </div>
            <div class="cube-validator cube-form-field cube-validator_invalid">
              <div class="cube-validator-content">
                <div class="tips" @click="ifTipMode=!ifTipMode">
                  <img src="https://oss.zhishijingling.com/jinriyouliao/list/question.png" class="icon">注意事项</div>
                <cube-input v-model="value" class="inputCoutentBook" placeholder="请输入标题 50字内" :maxlength="50"></cube-input>
              </div>
              <div class="cube-validator-msg">
                <span class="cube-validator-msg-def">此为必填项</span></div>
            </div>
          </div>
          <div class="cube-form-item border-bottom-1px subtitle">
            <div class="cube-form-label">
              <span>简介</span></div>
            <cube-input v-model="value" class="inputCoutent" placeholder="请填写简介 60字内" :maxlength="60"></cube-input>
          </div>
        </div>
      </div>
      <div class="cube-form-group borderBottom subtitle">
        <p class="cube-form-group-legend"></p>
        <div class="cube-form-group-content">
          <div class="cube-form-item border-bottom-1px">
            <div class="cube-form-label">
              <span>免费内容</span>
            </div>
            <div class="cube-form-field">
              <div style="padding-top: 2px;"></div>
              <div class="edit-content">
                <div>
                  <div>
                    <div class="edit-card">
                      <textarea maxlength="2000" placeholder="请输入免费内容，2000字以内" class="card-text"></textarea>
                      <div class="close-btn">
                        <span>+</span></div>
                    </div>
                    <cube-upload
                      action="//jsonplaceholder.typicode.com/photos/"
                      :simultaneous-uploads="1"
                      @files-added="filesAdded" :multiple="true"/>
                  </div>
                </div>
                <a  class="add_btn"></a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="cube-form-group">
        <p class="cube-form-group-legend"></p>
        <div class="cube-form-group-content">
          <div class="cube-form-item border-bottom-1px subtitle cube-form-item_required cube-form-item_invalid">
            <div class="cube-form-label">
              <span>收费内容</span></div>
            <div class="cube-validator cube-form-field cube-validator_invalid">
              <div class="cube-validator-content">
                <div class="edit-content">
                  <div>
                    <div class="edit-card">
                      <textarea placeholder="请输入正文内容" class="card-text"></textarea>
                      <div class="close-btn">
                        <span>+</span></div>
                    </div>
                    <cube-upload
                      action="//jsonplaceholder.typicode.com/photos/"
                      :simultaneous-uploads="1"
                      @files-added="filesAdded" :multiple="true"/>
                  </div>
                  <div class="add_box">
                    <img src="https://oss.zhishijingling.com/jinriyouliao/add.png" class="icon">
                    <span>添加更多内容</span></div>
                  <!----></div>
              </div>
              <div class="cube-validator-msg">
                <span class="cube-validator-msg-def">此为必填项</span></div>
            </div>
          </div>
        </div>
      </div>
      <div class="cube-form-group item-border">
        <p class="cube-form-group-legend"></p>
        <div class="cube-form-group-content">
          <div class="cube-form-item border-bottom-1px subtitle cube-form-item_required cube-form-item_invalid">
            <div class="cube-form-label">
              <span>售价</span></div>
            <div class="cube-validator cube-form-field cube-validator_invalid">
              <div class="cube-validator-content">
                <div class="set-price">
                  <div class="cube-input define-price">
                    <!---->
                    <input type="number" placeholder="填写金额/元，0则为免费" class="cube-input-field">
                    <!----></div>
                  <div class="right-btn">快速定价</div></div>
              </div>
              <div class="cube-validator-msg">
                <span class="cube-validator-msg-def">此为必填项</span></div>
            </div>
          </div>
        </div>
      </div>
      <div class="cube-form-group item-border">
        <p class="cube-form-group-legend"></p>
        <div class="cube-form-group-content">
          <div class="cube-form-item border-bottom-1px">
            <div class="cube-form-label">
              <span>不对返还</span></div>
            <div class="cube-form-field">
<!--              <cube-switch v-model="books.ifRefund" class="freetime-switch"></cube-switch>-->
              <div class="switch freetime-switch close" ></div>
              <p style="text-align: left; font-size: 0.9rem; color: rgb(166, 165, 165);">在结束后可操作是否返还/正确收款</p></div>
          </div>
        </div>
      </div>
      <div class="cube-form-group">
        <p class="cube-form-group-legend"></p>
        <div class="cube-form-group-content">
          <div class="cube-form-item border-bottom-1px" style="padding-top: 0px;">
            <div class="cube-form-label" style="display: none;">
              <span></span>
            </div>
            <div class="cube-form-field">
              <div class="subtitle" style="text-align: left;">个性模板</div>
              <p style="text-align: left; font-size: 0.9rem; color: rgb(166, 165, 165);">精美个性模板多选一</p>
              <div class="backimg">
                <div class="item active">
                  <img src="http://oss.zhishijingling.com/knowWireData/2022-08-07/2byubdchkliaokug.png"></div>
                <div class="item">
                  <img src="http://oss.zhishijingling.com/knowWireData/2022-08-07/1bybchkliaokug.png"></div>
                <div class="item">
                  <img src="http://oss.zhishijingling.com/appimg/0011bybchkliaokug.png"></div>
                <div class="item">
                  <img src="http://oss.zhishijingling.com/appimg/0020011bybchkliaokug.png"></div>
                <div class="item">
                  <img src="http://oss.zhishijingling.com/appimg/0030011bybchkliaokug.png"></div>
                <div class="item">
                  <img src="http://oss.zhishijingling.com/appimg/0040011bybchkliaokug.png"></div>
                <div class="item">
                  <img src="https://oss.zhishijingling.com/knowWireData/2026-03-08/ddb6fc49ef3b42d3891b2a230be67d7b1772943482982_167.png"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="cube-form-item border-bottom-1px">
        <div class="cube-form-label" style="display: none;">
          <span></span>
        </div>
        <div class="cube-form-field">
          <button type="button" class="cube-btn make-btn cube-btn-inline">
            <!---->生成料码</button></div>
      </div>
    </form>
    <div >
      <bottom-tab-bar />
    </div>
    <div class="iphoneX-bttom" style="height: 4rem;"></div>

    <div>
      <!--选择分类-->
      <div v-show="categoryPopupVisible" class="cube-popup cube-popup_mask cube-picker" style="z-index: 100;">
        <div class="cube-popup-mask" @click="closeCategoryPicker"></div>
        <div class="cube-popup-container">
          <div class="cube-popup-content">
            <div class="cube-picker-panel cube-safe-area-pb">
              <div class="cube-picker-choose border-bottom-1px">
                <span class="cube-picker-cancel" @click="closeCategoryPicker">取消</span>
                <span class="cube-picker-confirm" @click="confirmCategoryPicker">确定</span>
                <div class="cube-picker-title-group">
                  <h1 class="cube-picker-title">请选择分类</h1></div>
              </div>
              <div>
                <div class="scroll-list-wrap">
                  <div class="cube-scroll-wrapper">
                    <div class="cube-scroll-content" style="transition-timing-function: cubic-bezier(0.165, 0.84, 0.44, 1); transition-duration: 0ms; transform: translate(0px, 0px) scale(1) translateZ(0px);">
                      <div class="cube-scroll-list-wrapper" style="min-height: 0px;">
                        <div class="cube-radio-group border-top-1px border-bottom-1px">
                          <div
                            v-for="cat in categories"
                            :key="cat.id"
                            data-pos="left"
                            class="cube-radio"
                            :class="{ 'cube-radio_selected': tempSelectedCategoryId === cat.id }"
                            @click="tempSelectedCategoryId = cat.id"
                          >
                            <label class="cube-radio-wrap border-bottom-1px">
                              <input type="radio" class="cube-radio-input" :value="cat.id">
                              <span class="cube-radio-ui cubeic-round-border"><i></i></span>
                              <div class="list">
                                <div class="l_left">
                                  <img :src="cat.imgUrl">
                                  <div>{{ cat.name }}</div>
                                </div>
                                <div class="l_right">
                                  <img
                                    src="https://oss.zhishijingling.com/jinriyouliao/delete1.png"
                                    class="delete"
                                    @click.stop="onDeleteCategory(cat)"
                                  >
                                  <img
                                    src="https://oss.zhishijingling.com/jinriyouliao/edit1.png"
                                    class="edit"
                                    @click.stop="openCategoryEditor(cat)"
                                  >
                                </div>
                              </div>
                            </label>
                          </div>
                        </div>
                      </div>
                      <!----></div>
                    <!----></div>
                </div>
                <div class="addTeacher" @click="openCategoryEditor()">
                  <img src="https://oss.zhishijingling.com/jinriyouliao/popup/addTeacher.png">
                  <div>新增分类</div></div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!--新增编辑分类-->
      <div v-show="categoryEditVisible" class="cube-popup cube-popup_mask cube-picker" style="z-index: 100;">
        <div class="cube-popup-mask" @click="closeCategoryEditor"></div>
        <div class="cube-popup-container">
          <div class="cube-popup-content">
            <div class="cube-picker-panel cube-safe-area-pb">
              <div class="cube-picker-choose border-bottom-1px">
                <span class="cube-picker-cancel" @click="closeCategoryEditor">取消</span>
                <span class="cube-picker-confirm" @click="confirmCategoryEditor">确定</span>
                <div class="cube-picker-title-group">
                  <h1 class="cube-picker-title">新增/编辑分类</h1></div>
              </div>
              <div>
                <div class="editor">
                  <div class="input">
                    <div class="i_title">分类名：</div>
                    <cube-input v-model="editCategory.name" class="i_input" placeholder="请输入分类名 10字内" :maxlength="10"></cube-input>
                  </div>
                  <div class="input">
                    <cube-upload
                      :multiple="false"
                      :auto="false"
                      accept="image/*"
                      :max="1"
                      @files-added="onCategoryFilesAdded"
                    />
                  </div>
                  <div v-if="editCategory.imgUrl" class="input">
                    <img :src="editCategory.imgUrl" style="max-width: 6rem; max-height: 6rem; border-radius: .25rem;">
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
   </div>

</template>

<style>
.edit-card{
  position: relative;
  width: 100%;
  margin: 10px 0;
  border: .0831rem solid #f74905;
  border-radius: .25rem;
  padding: 1rem .7rem;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: justify;
  -webkit-justify-content: space-between;
  -ms-flex-pack: justify;
  justify-content: space-between;
}
</style>



// WEBPACK FOOTER //
// src/components/fabrication.vue